
function DonutCirkel({ middleRadius, circleID, circleWidth, chartClicked,
  color, visibility, textFlag }){

  const outerR = middleRadius + circleWidth * (circleID - 1)
  const innerR = middleRadius + circleWidth * (circleID - 2)

  const texts = {
    2:'Oorzaken watertekort',
    4:'Effecten op waterbeschikbaarheid',
    6:'Effecten op water- en bodemsysteem'
  }

  let text = (textFlag)
    ? (<g className='categoryText'>
      <path
        id={'donut' + circleID}
        visibility='hidden'
        d={`
          M ${-innerR}, 0
          a ${innerR},${innerR} 0 1,1 ${innerR * 2},0
          a ${innerR},${innerR} 0 1,1 ${-innerR * 2},0
          z
        `}
      />
      <text fontSize={16} fill='#635F5D' dy={-circleWidth/2 + 5} pointerEvents='none'
        opacity='0.9'>
        <textPath xlinkHref={'#donut' + circleID} textAnchor='middle' startOffset='25%'>
          {texts[circleID]}
        </textPath>
      </text>
    </g>
    )
    : null

  return (
    <g className="DonutCirkel" visibility={visibility}>
      <path
        fillRule={'evenodd'}
        fill={'#e7e5e5'}
        onClick={() => chartClicked()}
        opacity='1'
        d={`
          M ${-outerR}, 0
          a ${outerR},${outerR} 0 1,1 ${outerR * 2},0
          a ${outerR},${outerR} 0 1,1 ${-outerR * 2},0
          z

          M ${innerR}, 0
          a ${innerR},${innerR} 0 1,1 ${-innerR * 2},0
          a ${innerR},${innerR} 0 1,1 ${innerR * 2},0
          z
        `}
      />
      {text}
    </g>
  );
}

export default DonutCirkel;
